function onLayoutHeaderScrollHandler(event, context, selector) {
	const nav = document.querySelector('#td-toptab');
	const navBottom = nav?.getBoundingClientRect().bottom || 0;

	if (event.type === "scrolldown") {
		// going down, remove sticky
		const stickyHeaders = context.querySelectorAll(selector);
		for (const layout of stickyHeaders) {
			layout.classList.remove('v3-state-stuck');
		}
	} else if (event.type === "scrollup") {
		// going up
		const stickyHeaders = context.querySelectorAll(selector);
		for (const layout of stickyHeaders) {
			const header = layout.querySelector(".v3-layout-view__header");
			if (header) {
				const headerRect = header.getBoundingClientRect();
				if (headerRect.bottom <= navBottom) {
					layout.classList.add('v3-state-stuck');
				}
			}
		}
	}
}

function onTableCaptionScrollHandler(event, context, selector) {
	const nav = document.querySelector('#td-toptab');
	const navBottom = nav?.getBoundingClientRect().bottom || 0;

	if (event.type === "scrolldown") {
		// going down, remove sticky
		const stickyTables = context.querySelectorAll(selector);
		for (const table of stickyTables) {
			table.classList.remove('v3-state-stuck');
		}
	} else if (event.type === "scrollup") {
		// going up
		const stickyTables = context.querySelectorAll(selector);
		for (const table of stickyTables) {
			if (table.caption) {
				const captionRect = table.caption.getBoundingClientRect();
				if (captionRect.bottom <= navBottom) {
					table.classList.add('v3-state-stuck');
				}
			}
		}
	}
}

function setHeaderElementHeight({ target: header }) {
	var layout = header.closest(".v3-sticky-header");
	layout.style.setProperty("--v3-sys-caption-height", `${header.getBoundingClientRect().height}px`);
}

function initHeaderSizeTracking(layouts) {
	const sizeObserver = new ResizeObserver(entries => entries.forEach(setHeaderElementHeight));
	layouts.forEach(layout => {
		const header = layout.querySelector(".v3-layout-view__header");
		if (header) sizeObserver.observe(header);
	});
}


function setTableElementHeights({ target }) {
	if (target.caption) {
		target.style.setProperty("--v3-sys-caption-height", `${target.caption.getBoundingClientRect().height}px`);
	}
	target.style.setProperty("--v3-sys-table-head-height", `${target.tHead.getBoundingClientRect().height}px`);
}

function initTableSizeTracking(tables) {
	const sizeObserver = new ResizeObserver(entries => entries.forEach(setTableElementHeights));
	tables.forEach(table => sizeObserver.observe(table));
}

function initLayoutHeaders(context, selector = "section.v3-sticky-header") {
	context = context || document;
	const layouts = context.querySelectorAll(selector);
	initHeaderSizeTracking(layouts);

	const scrollView = document.body;
	const scrollHandler = e => onLayoutHeaderScrollHandler(e, context, selector);
	scrollView.addEventListener('scrollup', scrollHandler, { passive: true });
	scrollView.addEventListener('scrolldown', scrollHandler, { passive: true });
}

function initTableCaptions(context, selector = 'table.v3-sticky-table-headers') {
	context = context || document;
	const tables = context.querySelectorAll(selector);
	initTableSizeTracking(tables);
	const scrollView = document.body;
	const scrollHandler = e => onTableCaptionScrollHandler(e, context, selector);
	scrollView.addEventListener('scrollup', scrollHandler, { passive: true });
	scrollView.addEventListener('scrolldown', scrollHandler, { passive: true });
}

function init(context) {
	initLayoutHeaders(context);
	initTableCaptions(context);
}

export { init };